// Helper function for asset_type used in Card, RelatedCard, and GatedForms (Submit Btn)

/**
 * Derives localized action for content using asset type and duration
 * @param {object} copyData Localized: 'Read Article', 'Watch Webinar', etc.
 * @param {string} asset_type 'ebook', 'guide', etc.
 * @param {string} duration '4:24', '', etc.
 * @return {string} 'Read Ebook', 'Shau Video', etc.
 */
const getAction = (copyData, asset_type, duration) => {
    const actionDictionary = {
        "blog post": copyData.read_article,
        "case study": copyData.read_case_study,
        ebook: copyData.read_ebook,
        "fact sheet": copyData.read_fact_sheet,
        guide: copyData.read_guide,
        infographic: copyData.view_infographic,
        podcast: copyData.listen_now,
        report: copyData.read_report,
        video: copyData.watch_video,
        webinar: copyData.watch_webinar,
        "white paper": copyData.read_white_paper
    };

    if (duration) {
        return actionDictionary.video;
    }
    return actionDictionary[asset_type] || copyData.learn_more;
};

export default getAction;
